import { Box } from "@mui/material";
import React from "react";
import NewTax from "./Components/NewTax";
import NewTaxTable from "./Components/NewTaxTable";
import { useStyles } from "../../theme/styles";

const Category: React.FC = () => {
  const classes = useStyles();

  return (
    <Box sx={{ p: 2 }} className={classes.indexBox}>
      <NewTax />
      <Box sx={{ height: "75px" }} />
      <NewTaxTable />
    </Box>
  );
};

export default Category;
